import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/stations/classic/$stationId/")({
  validateSearch: z.object({
    stationGroupId: z.uuid().optional(),
  }),
})
